// Imports
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from '@material-ui/core'
import { removeGoogleCreds } from '../../actions/transactions/GLoginAction'
import { useHistory } from 'react-router-dom'
import axios from 'axios'

const GoogleLogoutButton = props => {
  const dispatch = useDispatch()
  const userObj = useSelector(state => state.GLoginReducer.oGoogle)

  let history = useHistory()

  const revokeIdToken = () => {
    window.google.accounts.id.revoke(userObj.email, done => {
      axios
        .get(`/User/Logout`)
        .then(resp => {
          if (
            resp.status === 200 &&
            resp.data.message === 'Logged Out successfully'
          ) {
            history.push('/Login')
            dispatch(removeGoogleCreds())
          }
        })
        .catch(error => {})
    })
  }

  // UI components
  return (
    <Button
      className='btn-outline-first border-1 m-2'
      onClick={revokeIdToken}
      variant='outlined'>
      Yes
    </Button>
  )
}

export default GoogleLogoutButton
